import * as angular from 'angular';
import * as _ from 'underscore';

interface ITags {
    [propName: string]: string[];
}

const allowedTags: ITags = {
    'h1': [],
    'h2': [],
    'h3': [],
    'b': [],
    'i': [],
    'em': [],
    'u': [],
    'strike': [],
    'strong': [],
    'ul': [],
    'ol': [],
    'li': [],
    'br': [],
    'p': [],
    'span': [],
    'div': [],
    'img': ['src', 'wight', 'height', 'alt']
};

export class HtmlService {
    filterWysiwygContent(html: string) {
        var parsed: HTMLElement[] = $.parseHTML(html) || [];
        return _.flatten(parsed.map(node => this.mapNode(node)))
            .map((node: Element) => node.outerHTML || node.nodeValue || '')
            .join('');
    }

    private mapNode(node: HTMLElement): Node[] {
        if (node.nodeType === Node.TEXT_NODE) {
            return [node];
        }

        var childNodes = _.flatten(
            _.toArray(node.childNodes)
            .map((node: HTMLElement) => this.mapNode(node))
        );

        var tagName = node.nodeName.toLowerCase();
        if (!allowedTags.hasOwnProperty(tagName)) {
            if (childNodes.length > 0) {
                return childNodes;
            } else if (node.innerText) {
                return [document.createTextNode(node.innerText)];
            } else {
                return [];
            }
        }

        var allowedAttributes = allowedTags[tagName];
        var element = document.createElement(tagName);
        allowedAttributes.forEach((attributeName: string) => {
            element.setAttribute(attributeName, node.getAttribute(attributeName));
        });

        if (childNodes.length > 0) {
            childNodes.forEach((subNode: Node) => {
                if (subNode) {
                    element.appendChild(subNode);
                }
            });
        } else {
            $(element).text(node.innerText);
        }

        return [element];
    }
}

angular.module('app.common').service('htmlService', HtmlService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/html.service.ts